import {get, post, postJson} from './axios'

// 系统批次短信效果分析

// const RESOURCE_BASE_PATH = '/jd-yusms'
const RESOURCE_BASE_PATH = '/sms/marketing'

// 营销效果分析客户详情
export const getDetailCustomer = p => get(`${RESOURCE_BASE_PATH}/detail/customer`, p);

// 营销效果分析订单详情
export const getDetailOrder = p => get(`${RESOURCE_BASE_PATH}/detail/order`, p);

// 营销效果分析商品详情
export const getDetailWare = p => get(`${RESOURCE_BASE_PATH}/detail/ware`, p);

// 获取营销效果分析
export const getEffectAnalyze = p => get(`${RESOURCE_BASE_PATH}/effect/analyze`, p);

// 查询营销效果分析列表
export const getEffectPage = p => get(`${RESOURCE_BASE_PATH}/page`, p);

// 获取官方效果分析详情
export const getOfficialData = p => get(`${RESOURCE_BASE_PATH}/effect/analyze/official`, p);